exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#alertMes {\n  position: fixed;\n  z-index: 200;\n  top: 50%;\n  left: 50%;\n  background-color: #000;\n  opacity: 0.7;\n  color: #fff;\n  font-size: 0.86rem;\n  padding: 0.54rem;\n  border-radius: 8px;\n  margin: -5.5rem 0 0 -5.5rem;\n  width: 10rem;\n  word-break: break-all;\n  text-align: center;\n}\n", ""]);

